export default __webpack_public_path__ + "static/media/539.ff451f24.gif";